import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from 'src/app/msal/msal.service';
import { AccountService } from 'src/app/services/account.service';
import { SubscriptionService } from '../../shared/subscription.service';

@Component({
  template: '',
})
export class LogoutComponent implements OnInit {
  constructor(
    private ngZone: NgZone,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private msalService: MsalService,
    private accountService: AccountService,
  ) {}

  async ngOnInit() {
    Meteor.logout();
    // @ts-ignore
    Meteor._localStorage.removeItem('Meteor.loginToken');
    // @ts-ignore
    Meteor._localStorage.removeItem('Meteor.loginTokenExpires');
    // @ts-ignore
    Meteor._localStorage.removeItem('Meteor.userId');
    this.accountService.removeStorageLoginEmail();
    this.subscriptionService.unsubscribe();
    // Check if we have an active MSAL account and logout if so
    const activeAccount = this.msalService.getActiveAccount();
    if (activeAccount) {
      this.msalService.logout();
    } else {
      this.ngZone.run(() => {
        this.router.navigateByUrl('/login').then(() => {
          Session.set('role', undefined);
        });
      });
    }
  }
}
